import { LooksInfusionSliderVariant } from './types';
import { BellaTestIds } from 'Common/qaIds';

type LooksInfusionVariantTestId =
    | BellaTestIds.pdpLooksInfusionVariantTop
    | BellaTestIds.pdpLooksInfusionVariantBottom
    | BellaTestIds.pdpLooksInfusionVariantNone;

const VariantTestId: Record<LooksInfusionSliderVariant, LooksInfusionVariantTestId> = {
    top: BellaTestIds.pdpLooksInfusionVariantTop,
    bottom: BellaTestIds.pdpLooksInfusionVariantBottom,
    none: BellaTestIds.pdpLooksInfusionVariantNone,
};

const useVariantTestId = (variant: LooksInfusionSliderVariant) => VariantTestId[variant];

export default useVariantTestId;
